<template>
  <div class="contact-form-section">
    <SectionHeader
      title="Leave a Message"
      :description="description"
      :extraClass="['text-left']"
    />
    <div class="form-wap contact-form">
      <a-form
        layout="horizontal"
        class="contact-form"
        :form="form"
        @submit="handleSubmit"
      >
        <a-row :gutter="24">
          <a-col :sm="12">
            <a-form-item
              label="First Name"
              :validate-status="handleError('firstname') ? 'error' : ''"
              :help="handleError('firstname') || ''"
            >
              <a-input
                placeholder="Enter your first name"
                v-decorator="[
                  'firstName',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Please enter first name!'
                      }
                    ]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :sm="12">
            <a-form-item
              label="Last Name"
              :validate-status="handleError('lastname') ? 'error' : ''"
              :help="handleError('lastname') || ''"
            >
              <a-input
                placeholder="Enter your last name"
                v-decorator="[
                  'lastName',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Please enter last name!'
                      }
                    ]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :sm="24">
            <a-form-item
              label="Your Email Address"
              :validate-status="handleError('email') ? 'error' : ''"
              :help="handleError('email') || ''"
            >
              <a-input
                v-decorator="[
                  'email',
                  {
                    rules: [
                      {
                        type: 'email',
                        message: 'The input is not valid E-mail!'
                      },
                      {
                        required: true,
                        message: 'Please input your E-mail!'
                      }
                    ]
                  }
                ]"
                type="email"
                placeholder="Enter your email address"
              />
            </a-form-item>
          </a-col>
          <a-col :sm="24">
            <a-form-item
              label="Enter Subject"
              :validate-status="handleError('subject') ? 'error' : ''"
              :help="handleError('subject') || ''"
            >
              <a-input
                placeholder="Enter subject here"
                v-decorator="[
                  'subject',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Please enter subject!'
                      }
                    ]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :sm="24">
            <a-form-item
              label="Type your message"
              :validate-status="handleError('description') ? 'error' : ''"
              :help="handleError('description') || ''"
            >
              <a-textarea
                :auto-size="{ minRows: 5, maxRows: 5 }"
                placeholder="Enter your message here"
                v-decorator="[
                  'message',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Please Enter Message!'
                      }
                    ]
                  }
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <div class="button-wrap">
          <a-form-item>
            <div class="custom-button">
              <a-button
                type="primary"
                html-type="submit"
                :loading="contactUsLoading"
                >Send Message</a-button
              >
            </div>
          </a-form-item>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import SectionHeader from "@/pageComponents/globalUi/section-header";
import { mapGetters } from "vuex";

const MISC_STORE_KEY = "miscStore";

export default {
  name: "ContactForm",
  components: {
    SectionHeader
  },
  computed: {
    ...mapGetters({
      contactUsLoading: `${MISC_STORE_KEY}/submitContactFormLoading`
    })
  },
  props: {
    description: {
      type: String,
      default: ""
    },
    mailTo: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      form: this.$form.createForm(this)
    };
  },
  mounted() {
    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      this.form.validateFields();
    });
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.mailDispatcher(values);
          this.form.resetFields();
        }
      });
    },
    async mailDispatcher(value) {
      let values = value;
      values = { ...values, adminEmail: this.mailTo };
      await this.$store.dispatch(`${MISC_STORE_KEY}/sendMail`, values);
    },
    // Only show error after a field is touched.
    handleError(val) {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched(val) && getFieldError(val);
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/_variable.scss";
@import "@/scss/_mixins.scss";
.contact-form {
  label {
    font-family: $content-font;
    font-size: 14px;
    font-weight: bold;
    text-transform: capitalize;
    margin-bottom: 7px;
  }
  .ant-form-item-required {
    &::before {
      display: none;
    }
  }
  .ant-form-item {
    margin-bottom: 35px;
  }
  .has-error {
    .ant-input {
      &:focus {
        border-right-width: none !important;
        box-shadow: none;
      }
    }
  }
  .custom-button {
    button {
      text-transform: capitalize;
      font-size: 12px;
      padding: 0 25px;
      height: 40px;
      font-weight: 500;
      background: $secondary-color;
      border-color: $secondary-color;
      &:hover {
        border-color: $secondary-color;
        background: transparent;
        color: $secondary-color;
      }
    }
  }
  input,
  textarea {
    font-family: $content-font;
    border: none !important;
    border-bottom: 2px solid #cacaca !important;
    color: #000;
    font-weight: 400;
    background: transparent !important;
    border-radius: 0 !important;
    padding: 0 0 10px 0;
    @include customTransition(0.2s, cubic-bezier(0.44, 0.9, 1, 1));
    &::-webkit-input-placeholder {
      /* Chrome/Opera/Safari */
      color: #3d3d3d !important;
      opacity: 1;
      font-weight: 400;
    }
    &::-moz-placeholder {
      /* Firefox 19+ */
      color: #3d3d3d !important;
      opacity: 1;
      font-weight: 400;
    }
    &:-ms-input-placeholder {
      /* IE 10+ */
      color: #3d3d3d !important;
      opacity: 1;
      font-weight: 400;
    }
    &:-moz-placeholder {
      /* Firefox 18- */
      color: #3d3d3d !important;
      opacity: 1;
      font-weight: 400;
    }
    &:focus {
      border-right-width: none !important;
      box-shadow: none;
      border-color: $dodger-blue !important;
    }
  }
  textarea {
    padding-top: 10px;
  }
}

@media only screen and (max-width: 575px) {
  .contact-form {
    .ant-form-item-label {
      label {
        text-align: left;
      }
    }
  }
}
</style>
